import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

const propTypes = {
  escapeForm: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  previousPageFunction: PropTypes.func.isRequired,
  renderCompanyInfo: PropTypes.func.isRequired,
  submitFunction: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const NewOrderFormTwo = ({
  invalid,
  escapeForm,
  renderCompanyInfo,
  submitting,
  submitFunction,
  previousPageFunction,
}) => (
  <div className="modal-wrap">
    <div className="container-fluid container-home">
      <div className="header">
        <div className="header-body align-items-center">
          <div className="row">
            <div className="col-sm-12">
              <span className="pull-right">
                <button
                  type="button"
                  className="btn btn-danger-outline"
                  onClick={() => escapeForm()}
                >
                  Cancel
                </button>
              </span>
              <h1 className="header-title">Client Admin</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="card-border">
            <div className="card-header">
              <div className="card-header-title">Client Admin Information</div>
            </div>
            <div className="card-block">
              {renderCompanyInfo()}
              <form className="small-form">
                <fieldset>
                  <div className="card card-block">
                    <div className="card-title">
                      <p className="card-text">
                        <strong>Client Admin</strong>
                      </p>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <Field
                          name="firstName"
                          type="text"
                          component={InputField}
                          label="First Name"
                          placeholder="Enter first name"
                          autoFocus
                        />
                      </div>
                      <div className="col-md-6">
                        <Field
                          name="lastName"
                          type="text"
                          component={InputField}
                          label="Last Name"
                          placeholder="Enter last name"
                        />
                      </div>
                    </div>
                    <Field
                      name="email"
                      type="text"
                      component={InputField}
                      label="Email"
                      placeholder="data@example.com"
                    />
                    <Field
                      name="phone"
                      type="text"
                      component={InputField}
                      label="Phone"
                      placeholder="123-456-6789"
                    />
                    <div className="form-buttons">
                      <p className="pull-right">
                        <button
                          type="button"
                          className="btn btn-secondary btn-back"
                          onClick={previousPageFunction}
                        >
                          Back
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={submitFunction}
                          disabled={checkButtonDisabled(invalid, submitting)}
                        >
                          Continue
                        </button>
                      </p>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

NewOrderFormTwo.propTypes = propTypes;

export default NewOrderFormTwo;
